var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTradingCycleDetailsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.707 17.833a.296.296 0 00-.368-.048 6.571 6.571 0 01-3.772.967 6.649 6.649 0 01-1.42-13.05.296.296 0 00.223-.29V1.7a.308.308 0 00-.356-.303A10.88 10.88 0 00.55 15.537c.919 3.022 4.068 6.098 7.09 6.98a10.97 10.97 0 009.617-1.57.297.297 0 00.037-.448 766.23 766.23 0 00-2.588-2.666zm5.604-12.228a.297.297 0 00-.46-.036l-2.006 1.989-1.064 1.04a.302.302 0 00-.055.356 6.6 6.6 0 01-.864 7.544.302.302 0 000 .41l2.992 3.023a.314.314 0 00.441 0A11.412 11.412 0 0020.3 5.623l.012-.018z",
    fill: "url(#prefix__paint0_linear_1_10975)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.343 3.47A12.09 12.09 0 0011.19 0a.314.314 0 00-.308.302v6.045a.296.296 0 00.29.296 5.398 5.398 0 013.458 1.517.308.308 0 00.423 0l1.74-1.692 2.551-2.54a.308.308 0 000-.458z",
    fill: "url(#prefix__paint1_linear_1_10975)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear_1_10975",
    x1: 11.177,
    y1: 1.395,
    x2: 11.177,
    y2: 23.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8684B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161551",
    stopOpacity: 0.94
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint1_linear_1_10975",
    x1: 15.163,
    y1: 0,
    x2: 15.163,
    y2: 8.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8684B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161551",
    stopOpacity: 0.94
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingCycleDetailsIcon);
export default __webpack_public_path__ + "static/media/trading-cycle-details-icon.2ad67ca53b6aadc3ed3f179695682049.svg";
export { ForwardRef as ReactComponent };